import _get from 'lodash/get';

import {
  FETCH_LEADS,
  UPDATE_LEAD,
  RESET_LEADS,
  FETCH_FILTERS_CONFIG,
  FETCH_LEAD_CONFIG,
  FETCH_LEAD_INFO,
  UPDATE_HOT_LEAD,
} from './lms.actions';
import { SUCCESS, FAILURE, REQUEST } from 'utils/actionGenerator';

const initialLeadsData = {
  new: {
    list: [],
    totalCount: null,
  },
  to_chase: {
    list: [],
    totalCount: null,
  },
  proposal_sent: {
    list: [],
    totalCount: null,
  },
  indent: {
    list: [],
    totalCount: null,
  },
  closed: {
    list: [],
    totalCount: null,
  },
  active: {
    list: [],
    totalCount: null,
  },
  deboarded: {
    list: [],
    totalCount: null,
  },
  common: {
    list: [],
    totalCount: null,
    status: '',
  },
};

const defaultState = {
  leadsData: { ...initialLeadsData },
  isFetching: false,
  config: {},
  leadInfo: {},
  selectedTab: '',
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case FETCH_LEADS[FAILURE]: {
      return { ...state, isFetching: true };
    }
    case FETCH_LEADS[SUCCESS]: {
      let type = (action.params.status && action.params.status.toLowerCase()) || 'common';
      let listData = action.response.data.list || [];
      let count = action.response.data.totalCount || 0;
      let newListObj = {};
      if (type) {
        newListObj = { ...state.leadsData[`${type}`] };
        newListObj.list = newListObj.list.length ? newListObj.list.concat(listData) : listData;
        newListObj.totalCount = count;
        state.leadsData[type] = newListObj;
        if (type === 'common') {
          let status = _get(newListObj, 'list[0].stage', '');
          let tab = '';
          if (['new', 'indent', 'to_chase', 'proposal_sent' , 'closed', 'active', 'deboarded'].includes(status.toLowerCase())) {
            tab = status.toLowerCase();
          }
          state.leadsData[tab] = newListObj;
          state.selectedTab = tab;
        }
      }
      return { ...state, isFetching: false };
    }
    case FETCH_LEADS[FAILURE]: {
      return { ...state, isFetching: false };
    }
    case UPDATE_LEAD[REQUEST]: {
      return { ...state, leadSubmitted: false };
    }
    case UPDATE_LEAD[SUCCESS]: {
      return { ...state, leadSubmitted: 'success' };
    }
    case UPDATE_LEAD[FAILURE]: {
      return { ...state, leadSubmitted: 'error' };
    }
    case FETCH_FILTERS_CONFIG[SUCCESS]: {
      return { ...state, filtersData: action.response.data };
    }
    case FETCH_FILTERS_CONFIG[FAILURE]: {
      return { ...state, filtersData: {} };
    }
    case RESET_LEADS: {
      const type = action.payload.type;
      if (type) {
        return {
          ...state,
          leadsData: {
            ...state.leadsData,
            [type]: {
              list: [],
              totalCount: null,
            },
          },
        };
      }
      return {
        ...state,
        leadsData: { ...initialLeadsData },
      };
    }
    case FETCH_LEAD_CONFIG[SUCCESS]: {
      return {
        ...state,
        config: action.response.data,
      };
    }
    case FETCH_LEAD_INFO[REQUEST]: {
      return {
        ...state,
        leadInfo: {
          fetched: false,
        },
      };
    }
    case FETCH_LEAD_INFO[SUCCESS]: {
      return {
        ...state,
        leadInfo: {
          ...action.response.data,
          fetched: true,
        },
      };
    }
    case FETCH_LEAD_INFO[FAILURE]: {
      return {
        ...state,
        leadInfo: {
          fetched: true,
        },
      };
    }
    case UPDATE_HOT_LEAD[REQUEST]: {
      return { ...state, hotLeadStatus: false };
    }
    case UPDATE_HOT_LEAD[SUCCESS]: {
      return { ...state, hotLeadStatus: 'success' };
    }
    case UPDATE_HOT_LEAD[FAILURE]: {
      return { ...state, hotLeadStatus: 'error' };
    }
    default:
      return { ...state };
  }
}
